import React, { useState, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import { FaSearch } from 'react-icons/fa';
import './ManageDiscountItems.scss';

interface DiscountItem {
  item_id: number;
  item_name: string;
}

interface Item {
  id: number;
  name: string;
}

interface ManageDiscountItemsProps {
  currentItems: DiscountItem[];
  availableItems: Item[];
  itemsToAdd: number[];
  itemsToRemove: number[];
  onAddItem: (itemId: number) => void;
  onRemoveItem: (itemId: number) => void;
}

const ManageDiscountItems: React.FC<ManageDiscountItemsProps> = ({
  currentItems,
  availableItems,
  itemsToAdd,
  itemsToRemove,
  onAddItem,
  onRemoveItem
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Get items not currently in the discount and not already added
  const availableToAdd = useMemo(() => {
    const currentItemIds = currentItems.map(item => item.item_id);
    return availableItems.filter(item =>
      !currentItemIds.includes(item.id) && !itemsToAdd.includes(item.id)
    );
  }, [availableItems, currentItems, itemsToAdd]);

  // Filter available items based on search
  const filteredAvailableItems = useMemo(() => {
    if (!searchTerm.trim()) return availableToAdd;
    return availableToAdd.filter(item =>
      item.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [availableToAdd, searchTerm]);

  return (
    <div className="manage-discount-items-simple">
      {/* Search and add section */}
      <div className="add-items-section">
        <div className="section-header">
          <h4>Agregar Ítems</h4>
          <p className="section-description">
            Busca y selecciona ítems para agregar al descuento
          </p>
        </div>

        <div className="search-bar-container">
          <div className="search-input-wrapper">
            <FaSearch className="search-icon" />
            <Form.Control
              type="text"
              placeholder="Buscar ítems para agregar..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            {searchTerm && (
              <button
                className="clear-search"
                onClick={() => setSearchTerm('')}
              >
                ×
              </button>
            )}
          </div>
        </div>

        {/* Available Items List */}
        {availableToAdd.length === 0 ? (
          <div className="empty-state">
            Todos los ítems ya están incluidos en este descuento
          </div>
        ) : filteredAvailableItems.length === 0 ? (
          <div className="no-results">
            No se encontraron ítems que coincidan con "{searchTerm}"
          </div>
        ) : (
          <div className="items-list scrollable">
            {filteredAvailableItems.map(item => (
              <div
                key={item.id}
                className="item-row"
                onClick={() => onAddItem(item.id)}
              >
                <input
                  type="checkbox"
                  checked={false}
                  onChange={() => onAddItem(item.id)}
                  className="item-checkbox"
                  id={`add-${item.id}`}
                />
                <label htmlFor={`add-${item.id}`} className="item-label">
                  {item.name}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ManageDiscountItems;
